module.exports = __webpack_public_path__ + "media/flags/pr-00f681ed.svg";